import {
  productTableWindow,
  companyTableWindow,
  cropTableWindow,
  fertiProductTableWindow,
  sectorTableWindow,
  form1,
  form2,
  form3,
  form4,
  form5,
  companyRowsValid,
  productRowsValid,
  fertiProductRowsValid,
  cropRowsValid,
  sectorRowsValid,
  companyRows,
  productRows,
  fertiProductRows,
  cropRows,
  sectorRows,
  btnModal1,
  btnModal2,
  btnModal3,
  btnModal4,
  btnModal5,
  updateWindow1,
  updateWindow2,
  updateWindow3,
  updateWindow4,
  updateWindow5,
  updateFormColumn1,
  updateFormColumn2,
  updateFormColumn3,
  updateFormColumn4,
  updateFormColumn5,
} from "./controller.js";

import { headerCompany, headerSector } from "./model/modelCompany.js";

import { headerProduct } from "./model/modelProducts.js";

import { headerFertiProduct } from "./model/modelFertiProducts.js";

import { headerCrop } from "./model/modelCrops.js";

export const renderNavBtns = function (menuNav, type) {
  const typeString = checkType(type);
  const markup = `<button class="btn menu__btn menu_nav_btn addRow_btn">
    <span>Aggiungi ${typeString}</span>
  </button>`;
  menuNav.insertAdjacentHTML("afterbegin", markup);
};

const checkType = function (type) {
  if (type === "product") {
    console.log("product");
    return "Prodotto";
  }
  if (type === "fertiProduct") {
    console.log("fertiProduct");
    return "Prodotto";
  }
  if (type === "crop") {
    console.log("crop");
    return "Coltura";
  }
  if (type === "company") {
    console.log("company");
    return "Azienda";
  }
  if (type === "sector") {
    console.log("sector");
    return "Settore";
  }
};

export const newRowId = function (arrayRows, rowId) {
  console.log(arrayRows);
  if (arrayRows.length === 0) {
    const newId = "00001";
    return newId;
  }

  if (arrayRows.length !== 0) {
    const allId = arrayRows.map((r) => Number(r[rowId]));
    console.log(allId);
    const maxId = Math.max(...allId);
    console.log(maxId);
    const newId = String(maxId + 1).padStart(5, "0");

    console.log(newId);
    return newId;
  }
};

export const clearTable = function () {
  cropTableWindow.innerHTML = "";
  productTableWindow.innerHTML = "";
  fertiProductTableWindow.innerHTML = "";
  companyTableWindow.innerHTML = "";
  sectorTableWindow.innerHTML = "";
  //fertiTableWindow.innerHTML = "";
};

export const deleteForm = function (type) {
  const form = selectForm(type);
  form.innerHTML = "";
};

export const selectForm = function (type) {
  let form;
  if (type === "company") form = form1;
  if (type === "product") form = form2;
  if (type === "crop") form = form3;
  if (type === "fertiProduct") form = form4;
  if (type === "sector") form = form5;
  console.log(form);
  return form;
};

export const createOriginalRows = function (type) {
  let originalRows;
  if (type === "company") originalRows = companyRowsValid(companyRows);
  if (type === "product") originalRows = productRowsValid(productRows);
  if (type === "fertiProduct")
    originalRows = fertiProductRowsValid(fertiProductRows);
  if (type === "crop") originalRows = cropRowsValid(cropRows);
  if (type === "sector") originalRows = sectorRowsValid(sectorRows);
  return originalRows;
};

export const lockEventListenersTable = function (elArray) {
  console.log("Locking elements:", elArray);
  elArray.forEach((el) => {
    console.log("Element to lock:", el);
    if (el) {
      el.classList.add("no-pointer-events");
      el.style.pointerEvents = "none";
      console.log("Added no-pointer-events class to:", el);
    } else {
      console.warn("Element is null or undefined");
    }
  });
};

export const unlockEventListenersTable = function (elArray) {
  console.log("Unlocking elements:", elArray);
  elArray.forEach((el) => {
    console.log("Element to unlock:", el);
    if (el) {
      el.classList.remove("no-pointer-events");
      el.style.pointerEvents = "";
      console.log("Removed no-pointer-events class from:", el);
    } else {
      console.warn("Element is null or undefined");
    }
  });
};

export const selectBtnModal = function (type) {
  let btnModal;
  if (type === "company") btnModal = btnModal1;
  if (type === "product") btnModal = btnModal2;
  if (type === "crop") btnModal = btnModal3;
  if (type === "fertiProduct") btnModal = btnModal4;
  if (type === "sector") btnModal = btnModal5;
  return btnModal;
};

export const selectUpdateWindow = function (type) {
  let updateWindow;
  if (type === "company") updateWindow = updateWindow1;
  if (type === "product") updateWindow = updateWindow2;
  if (type === "crop") updateWindow = updateWindow3;
  if (type === "fertiProduct") updateWindow = updateWindow4;
  if (type === "sector") updateWindow = updateWindow5;
  return updateWindow;
};

export const createFormMarkup = function (type) {
  let markup;
  if (type === "company")
    markup = `<div class="upload__column1">
    <h3 class="upload__heading">Aggiungi Azienda</h3>
    <label class="upload__label">Azienda</label>
    <input  required name="company" type="text"/>
    <label class="upload__label">Via</label>
    <input  required name="street" type="text"/>
    <label class="upload__label">Città</label>
    <input  required name="city" type="text"/>
    <label class="upload__label">Provincia</label>
    <input  required name="province" type="text"/>
    <label class="upload__label">Stato</label>
    <input  required name="country" type="text"/>
    <label class="upload__label">Tel</label>
    <input  required name="tel" type="number"/>

    </div> 
    <button class="btn upload__btn uploadCompany__btn">
    <span>Salva</span>
    </button>`;

  if (type === "product")
    markup = `<div class="upload__column2">
      <h3 class="upload__heading">Aggiungi Prodotto</h3>
      <label class="upload__label">Prodotto</label>
      <input  required name="product" type="text"/>
      <label class="upload__label">N</label>
      <input  required name="countN" type="number" step="0.01" min="0"/>
      <label class="upload__label">P2O5</label>
      <input  required name="countP2O5" type="number" step="0.01"  min="0"/>
      <label class="upload__label">K2O</label>
      <input  required name="countK2O" type="number" step="0.01" min="0"/>
      <label class="upload__label">CaO</label>
      <input  required name="countCaO" type="number" step="0.01" min="0"/>
      <label class="upload__label">MgO</label>
      <input  required name="countMgO" type="number" step="0.01" min="0"/>
      <label class="upload__label">SO3</label>
      <input  required name="countSO3" type="number" step="0.01" min="0"/>
      <!--<label class="upload__label">Euro/kg</label>
      <input  required name="countEurokg" type="number" step="0.01" min="0"/>-->
  
      </div> 
      <button class="btn upload__btn uploadProduct__btn">
      <span>Salva</span>
      </button>`;
  if (type === "crop")
    markup = `<div class="upload__column3">
          <h3 class="upload__heading">Aggiungi Coltura</h3>
          <label class="upload__label">Coltura</label>
          <input  required name="crop" type="text"/>
          <label class="upload__label">N</label>
          <input  required name="countN" type="number"  step="0.01" min="0"/>
          <label class="upload__label">P2O5</label>
          <input  required name="countP2O5" type="number"  step="0.01" min="0"/>
          <label class="upload__label">K2O</label>
          <input  required name="countK2O" type="number" step="0.01" min="0"/>
          <label class="upload__label">CaO</label>
          <input  required name="countCaO" type="number" step="0.01" min="0"/>
          <label class="upload__label">MgO</label>
          <input  required name="countMgO" type="number" step="0.01" min="0"/>
          <label class="upload__label">SO3</label>
          <input  required name="countSO3" type="number" step="0.01" min="0"/>
      
          </div> 
          <button class="btn upload__btn uploadCrop__btn">
          <span>Salva</span>
          </button>`;
  if (type === "fertiProduct")
    markup = `<div class="upload__column4">
              <h3 class="upload__heading">Aggiungi Prodotto</h3>
              <label class="upload__label">Prodotto</label>
              <input  required name="product" type="text"/>
              <label class="upload__label">N</label>
              <input  required name="countN" type="number" step="0.01" min="0"/>
              <label class="upload__label">P2O5</label>
              <input  required name="countP2O5" type="number" step="0.01" min="0"/>
              <label class="upload__label">K2O</label>
              <input  required name="countK2O" type="number" step="0.01" min="0"/>
              <label class="upload__label">CaO</label>
              <input  required name="countCaO" type="number" step="0.01" min="0"/>
              <label class="upload__label">MgO</label>
              <input  required name="countMgO" type="number" step="0.01" min="0"/>
              <label class="upload__label">SO3</label>
              <input  required name="countSO3" type="number" step="0.01" min="0"/>
              <!--<label class="upload__label">Euro/kg</label>
              <input  required name="countEurokg" type="number" step="0.01" min="0"/>-->
              <label class="upload__label">Conducibilità</label>
              <input  required name="conductivity" type="number" step="0.01" min="0"/>
              <label class="upload__label">Peso specifico (kg/l)</label>
              <input  required name="specificWeight" type="number" step="0.01" min="1"/>
              <label class="upload__label">Coefficiente di solubilizzazione</label>
              <input  required name="solubilCoeff" type="number" step="0.01" min="0"/>
          
              </div> 
              
              <button class="btn upload__btn uploadFertiProduct__btn">
              <span>Salva</span>
              </button>`;
  if (type === "sector")
    markup = `<div class="upload__column_sector">
              <h3 class="upload__heading">Aggiungi Settore</h3>
              <label class="upload__label">Nome settore</label>
              <input  required name="name" type="text"/>
              <label class="upload__label">Azienda</label>
              <select id="select-company" >
                <option value=""> --Selezionare azienda--</option>
                    </select>
              <label class="upload__label">Coltura</label>
            
              <select id="crop-select" >
                <option value=""> --Selezionare coltura--</option>
                    </select>
                    
              <label class="upload__label">Lunghezza (m)</label>
              <input  required name="length" type="number" step="0.01" min="0" id="sector-length-input"/>
              <label class="upload__label">Larghezza(m)</label>
              <input  required name="width" type="number" step="0.01" min="0" id="sector-width-input"/>
              <label class="upload__label">Area (ha)</label>
              <input name="area" type="number" step="0.0001" min="0" id="sector-area-input" readonly style="background:#f0f0f0;"/>
              <label class="upload__label">Distanza tra file di erogazione (m)</label>
              <input  required name="distanceSupplyRows" type="number" step="0.01" min="0"/>
              <label class="upload__label">Distanza fra erogatori sulla linea (cm)</label>
              <input  required name="distanceSuppliers" type="number" step="0.01" min="0"/>
              <label class="upload__label">Portata nominale dell'erogatore a pressione d'esercizio prescelta (l/h)</label>
              <input  required name="nominalFlowRate" type="number" step="0.01" min="0"/>
              <label class="upload__label">Portata di fertiniezione, da curva pressione-portata data dal costruttore, per pressione d'esercizio prescelta (l/h)</label>
              <input  required name="fertiFlowRate" type="number" step="0.01" min="0"/>
              <label class="upload__label">Lunghezza tubi collettori (m)</label>
              <input  required name="pipeLength" type="number" step="0.01" min="0"/>
              
          
              </div> 
              <button class="btn upload__btn uploadSector__btn">
              <span>Salva</span>
              </button>`;

  return markup;
};

export const createAddedRow = function (type, addedRowId, inputValues) {
  let updatedRow;
  if (type === "company")
    updatedRow = {
      companyId: addedRowId,
      company: inputValues.company,
      address: {
        street: inputValues.street,
        city: inputValues.city,
        province: inputValues.province,
        country: inputValues.country,
      },
      tel: inputValues.tel,
    };
  if (type === "product")
    updatedRow = {
      productId: addedRowId,
      product: inputValues.product,
      countN: inputValues.countN,
      countP2O5: inputValues.countP2O5,
      countK2O: inputValues.countK2O,
      countCaO: inputValues.countCaO,
      countMgO: inputValues.countMgO,
      countSO3: inputValues.countSO3,
      countEurokg: inputValues.countEurokg,
    };
  if (type === "fertiProduct")
    updatedRow = {
      productId: addedRowId,
      product: inputValues.product,
      countN: inputValues.countN,
      countP2O5: inputValues.countP2O5,
      countK2O: inputValues.countK2O,
      countCaO: inputValues.countCaO,
      countMgO: inputValues.countMgO,
      countSO3: inputValues.countSO3,
      countEurokg: inputValues.countEurokg,
      conductivity: inputValues.conductivity,
      specificWeight: inputValues.specificWeight,
      solubilCoeff: inputValues.solubilCoeff,
    };
  if (type === "crop")
    updatedRow = {
      cropId: addedRowId,
      crop: inputValues.crop,
      countN: inputValues.countN,
      countP2O5: inputValues.countP2O5,
      countK2O: inputValues.countK2O,
      countCaO: inputValues.countCaO,
      countMgO: inputValues.countMgO,
      countSO3: inputValues.countSO3,
    };
  if (type === "sector") {
    updatedRow = {
      sectorId: addedRowId,
      name: inputValues.name,
      companyId: inputValues.company,
      cropId: inputValues.crop,
      length: inputValues.length,
      width: inputValues.width,
      distanceSupplyRows: inputValues.distanceSupplyRows,
      distanceSuppliers: inputValues.distanceSuppliers,
      nominalFlowRate: inputValues.nominalFlowRate,
      fertiFlowRate: inputValues.fertiFlowRate,
      pipeLength: inputValues.pipeLength,
    };
  }

  return updatedRow;
};

export const createRowsToRender = async function (tableRows, type) {
  console.log(tableRows);
  let rows;
  if (type === "company") {
    // 1.Create an array of arrays for the rows
    rows = tableRows.map((r) => {
      //const rowArray = [r.companyId, r.company, "", r.tel, "", ""];
      const rowArray = [r.company, "", r.tel, "", ""];
      return rowArray;
    });
    const positionAddress = 1;
    const positionSectors = 3;
    //const positionUpdate = 5;
    console.log(tableRows);
    //2.Transform sectors array into a string
    const originalSectorRows = await sectorRowsValid();
    if (!originalSectorRows) {
      console.error("Failed to load sectors");
      return rows;
    }
    let sectors = [];
    for (let i = 0; i < tableRows.length; i++) {
      sectors[i] = "";
    }
    console.log(sectors);

    tableRows.forEach((company, i) => {
      const currSectors = originalSectorRows.filter(
        (sector) => sector.companyId === company.companyId,
      );
      console.log(currSectors);
      sectors[i] = currSectors;
    });
    console.log(sectors);

    tableRows.map((r, i) => {
      let sectorsString = "";
      console.log(sectors[i]);
      sectors[i].forEach((s) => {
        let currSectorString;
        if (sectorsString === "") currSectorString = `${s.name}`;
        if (sectorsString !== "") currSectorString = `<br> ${s.name}`;
        sectorsString = sectorsString + currSectorString;
      });
      rows[i][positionSectors] = sectorsString;
    });

    //3.Transform address object in to a string
    tableRows.map((r, i) => {
      console.log(r);
      const addressString = `${r.address.street}<br>
      ${r.address.city}<br>
      ${r.address.province} -
      ${r.address.country}`;
      rows[i][positionAddress] = addressString;
    });
    console.log(rows);
  }
  if (type === "product") {
    // 1.Create an array of arrays for the rows
    rows = tableRows.map((r) => {
      const rowArray = [
        r.productId,
        r.product,
        r.countN,
        r.countP2O5,
        r.countK2O,
        r.countCaO,
        r.countMgO,
        r.countSO3,
        "",
        "",
      ];
      return rowArray;
    });
  }
  if (type === "fertiProduct") {
    // 1.Create an array of arrays for the rows
    rows = tableRows.map((r) => {
      const rowArray = [
        r.productId,
        r.product,
        r.countN,
        r.countP2O5,
        r.countK2O,
        r.countCaO,
        r.countMgO,
        r.countSO3,
        "",
        r.conductivity,
        r.specificWeight,
        r.solubilCoeff,
        "",
      ];
      console.log(rowArray);
      return rowArray;
    });
  }
  if (type === "crop") {
    // 1.Create an array of arrays for the rows
    rows = tableRows.map((r) => {
      const rowArray = [
        r.cropId,
        r.crop,
        r.countN,
        r.countP2O5,
        r.countK2O,
        r.countCaO,
        r.countMgO,
        r.countSO3,
        "",
      ];
      return rowArray;
    });
  }
  if (type === "sector") {
    // 1.Create an array of arrays for the rows
    rows = tableRows.map((r) => {
      //Create company to render
      const originalCompanyRows = companyRowsValid(companyRows);
      console.log(r);

      const currCompany = originalCompanyRows.find(
        (row) => row.companyId === r.companyId,
      );
      console.log(currCompany);
      const companyToRender = `${currCompany.companyId} - ${currCompany.company}`;

      //Create crop to render
      const originalCropRows = cropRowsValid(cropRows);
      const currCrop = originalCropRows.find((row) => row.cropId === r.cropId);
      const cropToRender = `${currCrop.cropId} - ${currCrop.crop}`;

      const rowArray = [
        r.sectorId,
        r.name,
        companyToRender,
        cropToRender,
        r.length,
        r.width,
        r.distanceSupplyRows,
        r.distanceSuppliers,
        r.nominalFlowRate,
        r.fertiFlowRate,
        r.pipeLength,
        "",
      ];

      console.log(rowArray);
      return rowArray;
    });
  }
  return rows;
};

export const selectRowId = function (type) {
  let rowId;
  if (type === "company") rowId = "companyId";
  if (type === "product") rowId = "productId";
  if (type === "fertiProduct") rowId = "productId";
  if (type === "crop") rowId = "cropId";
  if (type === "sector") rowId = "sectorId";
  return rowId;
};

export const selectPositionUpdate = function (type) {
  let positionUpdate;
  if (type === "company") positionUpdate = 5;
  if (type === "product") positionUpdate = 9;
  if (type === "fertiProduct") positionUpdate = 12;
  if (type === "crop") positionUpdate = 8;
  if (type === "sector") positionUpdate = 11;
  return positionUpdate;
};

export const selectEuroPositionUpdate = function (type) {
  let euroPositionUpdate;
  if (type === "product") euroPositionUpdate = 8;
  if (type === "fertiProduct") euroPositionUpdate = 8;

  return euroPositionUpdate;
};

export const addRowUpdateBtns = function (
  originalRows,
  rows,
  rowId,
  positionUpdate,
  euroPositionUpdate,
) {
  console.log("addRowUpdateBtns inputs:", {
    originalRows,
    rows,
    rowId,
    positionUpdate,
    euroPositionUpdate,
  });

  if (!originalRows || !originalRows[0]) {
    console.error("originalRows is empty or undefined");
    return rows;
  }

  originalRows.map((r, i) => {
    console.log("Processing row:", r, "rowId:", rowId, "value:", r[rowId]);
    rows[i][euroPositionUpdate] = `<button class="btn euro-tiny_btn">
          <img src='/icons/euro-logo.png' class="tiny_icon euro-tiny_icon" data-row=${r[rowId]}></img>
        </button>`;
    rows[i][positionUpdate] = `<button class="btn update-tiny_btn">
          <img src='/icons/update_img.jpeg' class="tiny_icon update-tiny_icon" data-row=${r[rowId]}></img>
        </button>
        <button class="btn delete-tiny_btn">
          <img src='/icons/delete_icon.jpeg' class="tiny_icon delete-tiny_icon" data-row=${r[rowId]}></img>
        </button>`;
  });
  return rows;
};

export const createFinalRows = function (
  type,
  currAccStatus,
  tableRows,
  rows,
  rowId,
  positionUpdate,
  euroPositionUpdate,
) {
  let finalRows;
  if (
    (type === "company") |
    (type === "sector") |
    (type === "product" && currAccStatus === "admin") |
    (type === "crop" && currAccStatus === "admin") |
    (type === "fertiProduct" && currAccStatus === "admin")
  ) {
    finalRows = addRowUpdateBtns(
      tableRows,
      rows,
      rowId,
      positionUpdate,
      euroPositionUpdate,
    );
    console.log(finalRows);
    return finalRows;
  }
  if (
    (type === "product" && currAccStatus === "std") |
    (type === "crop" && currAccStatus === "std") |
    (type === "fertiProduct" && currAccStatus === "std")
  ) {
    finalRows = rows.map((r) => r.slice(0, -1));
    return finalRows;
  }
};

export const createHeader = function (originalHeader, type, currAccStatus) {
  let header;
  if (
    (type === "sector") |
    (type === "product" && currAccStatus === "admin") |
    (type === "crop" && currAccStatus === "admin") |
    (type === "fertiProduct" && currAccStatus === "admin")
  ) {
    header = [...originalHeader, "Modifiche"];
    console.log(header);
    return header;
  }
  if (type === "company") {
    header = [...originalHeader, "Settori", "Modifiche"];
    console.log(header);
    return header;
  }
  if (
    (type === "product" && currAccStatus === "std") |
    (type === "crop" && currAccStatus === "std") |
    (type === "fertiProduct" && currAccStatus === "std")
  ) {
    header = selectHeader(type);
    return header;
  }
};

export const selectHeader = function (type) {
  let header;
  if (type === "company") header = headerCompany;
  if (type === "product") header = headerProduct;
  if (type === "fertiProduct") header = headerFertiProduct;
  if (type === "crop") header = headerCrop;
  if (type === "sector") header = headerSector;
  return header;
};

export const renderTableArray = function (
  header,
  rows,
  tableWindow,
  icon,
  theadClass,
) {
  tableWindow.classList.remove("hidden");
  console.log(rows);
  const th = header
    .map((head, i) => {
      let markup;
      if (i === 0)
        markup = `<th class="headerColumn" data-column="${i}">${head} ${icon}</th>`;
      if (i === 1)
        markup = `<th class="headerColumn" data-column="${i}">${head} ${icon}</th>`;
      if (i !== 0 && i !== 1) markup = `<th>${head}</th>`;

      return markup;
    })
    .toString("")
    .replaceAll(",", "");

  console.log(rows);
  const tr = rows
    .map((row) => {
      const td = row
        .map((v) => `<td>${v}</td>`)
        .toString("")
        .replaceAll(",", "");

      return `<tr>${td}</tr>`;
    })
    .toString("")
    .replaceAll(",", "");

  const markup = ` <table class='myTable'>
                      <thead class=${theadClass}>
                        <tr>
                          ${th}
                        </tr>
                      </thead>
                      
                        <tbody >
                          ${tr}
                        </tbody>
                      
                      </table>`;

  tableWindow.insertAdjacentHTML("beforeend", markup);

  const table = tableWindow.querySelector(".myTable");
  const tbody = table.querySelector("tbody");
  const rowsToSort = Array.from(tbody.querySelectorAll("tr"));

  sortRows(0, rowsToSort, tbody);
};

export const selectUpdateFormColumn = function (type) {
  let updateFormColumn;
  if (type === "company") updateFormColumn = updateFormColumn1;
  if (type === "product") updateFormColumn = updateFormColumn2;
  if (type === "product") updateFormColumn = updateFormColumn3;
  if (type === "fertiProduct") updateFormColumn = updateFormColumn4;
  if (type === "sector") updateFormColumn = updateFormColumn5;
  return updateFormColumn;
};

export const createUpdateRowMarkup = function (type, currentOriginalRow) {
  console.log(currentOriginalRow, type);
  let markup;
  if (type === "company")
    markup = `<div class="upload__column1">
              <h3 class="upload__heading">Modifica Azienda</h3>
              <label class="upload__label">Azienda</label>
              <input value="${currentOriginalRow.company}" required name="company" type="text"/>
              <label class="upload__label">Via</label>
              <input value="${currentOriginalRow.address.street}" required name="street" type="text"/>
              <label class="upload__label">Città</label>
              <input value="${currentOriginalRow.address.city}" required name="city" type="text"/>
              <label class="upload__label">Provincia</label>
              <input value="${currentOriginalRow.address.province}" required name="province" type="text"/>
              <label class="upload__label">Stato</label>
              <input value="${currentOriginalRow.address.country}" required name="country" type="text"/>
              <label class="upload__label">Tel</label>
              <input value="${currentOriginalRow.tel}" required name="tel" type="number"/>
              
            </div> 
            <button class="btn upload__btn">
              <span>Salva</span>
            </button>`;
  if (type === "product")
    markup = `<div class="upload__column2">
            <h3 class="upload__heading">Modifica Prodotto</h3>
            <label class="upload__label">Prodotto</label>
            <input value="${currentOriginalRow.product}" required name="product" type="text"/>
            <label class="upload__label">N</label>
            <input value="${currentOriginalRow.countN}" required name="countN" type="number" step="0.01" min="0"/>
            <label class="upload__label">P2O5</label>
            <input value="${currentOriginalRow.countP2O5}" required name="countP2O5" type="number" step="0.01" min="0"/>
            <label class="upload__label">K2O</label>
            <input value="${currentOriginalRow.countK2O}" required name="countK2O" type="number" step="0.01" min="0"/>
            <label class="upload__label">CaO</label>
            <input value="${currentOriginalRow.countCaO}" required name="countCaO" type="number" step="0.01" min="0"/>
            <label class="upload__label">MgO</label>
            <input value="${currentOriginalRow.countMgO}" required name="countMgO" type="number" step="0.01" min="0"/>
            <label class="upload__label">SO3</label>
            <input value="${currentOriginalRow.countSO3}" required name="countSO3" type="number" step="0.01" min="0"/>
            <!--<label class="upload__label">Euro/kg</label>
            <input value="${currentOriginalRow.countEurokg}" required name="countEurokg" type="number" step="0.01" min="0"/>-->
            
          </div> 
         
          <button class="btn uploadProduct__btn">
            <span>Salva</span>
          </button>`;
  if (type === "fertiProduct")
    markup = `<div class="upload__column4">
                    <h3 class="upload__heading">Modifica Prodotto</h3>
                    <label class="upload__label">Prodotto</label>
                    <input value="${currentOriginalRow.product}" required name="product" type="text"/>
                    <label class="upload__label">N</label>
                    <input value="${currentOriginalRow.countN}" required name="countN" type="number" step="0.01" min="0"/>
                    <label class="upload__label">P2O5</label>
                    <input value="${currentOriginalRow.countP2O5}" required name="countP2O5" type="number" step="0.01" min="0"/>
                    <label class="upload__label">K2O</label>
                    <input value="${currentOriginalRow.countK2O}" required name="countK2O" type="number" step="0.01" min="0"/>
                    <label class="upload__label">CaO</label>
                    <input value="${currentOriginalRow.countCaO}" required name="countCaO" type="number" step="0.01" min="0"/>
                    <label class="upload__label">MgO</label>
                    <input value="${currentOriginalRow.countMgO}" required name="countMgO" type="number" step="0.01" min="0"/>
                    <label class="upload__label">SO3</label>
                    <input value="${currentOriginalRow.countSO3}" required name="countSO3" type="number" step="0.01" min="0"/>
                    <!--<label class="upload__label">Euro/kg</label>
                    <input value="${currentOriginalRow.countEurokg}" required name="countEurokg" type="number" step="0.01" min="0"/>-->
                    <label class="upload__label">Conducibilità</label>
                    <input value="${currentOriginalRow.conductivity}" required name="conductivity" type="number" step="0.01" min="0"/>
                    <label class="upload__label">Peso specifico (kg/l) (mS/cm)</label>
                    <input value="${currentOriginalRow.specificWeight}" required name="specificWeight" type="number" step="0.01" min="1"/>
                    <label class="upload__label">Coeff. di solubilizz.</label>
                    <input value="${currentOriginalRow.solubilCoeff}" required name="solubilCoeff" type="number" step="0.01" min="0"/>
                    
                  </div> 
                 
                  <button class="btn uploadFertiProduct__btn">
                    <span>Salva</span>
                  </button>`;
  if (type === "crop")
    markup = `<div class="upload__column3">
          <h3 class="upload__heading">Modifica Coltura</h3>
          <label class="upload__label">Coltura</label>
          <input value="${currentOriginalRow.crop}" required name="crop" type="text"/>
          <label class="upload__label">N</label>
          <input value="${currentOriginalRow.countN}" required name="countN" type="number" step="0.01" min="0"/>
          <label class="upload__label">P2O5</label>
          <input value="${currentOriginalRow.countP2O5}" required name="countP2O5" type="number" step="0.01" min="0"/>
          <label class="upload__label">K2O</label>
          <input value="${currentOriginalRow.countK2O}" required name="countK2O" type="number" step="0.01" min="0"/>
          <label class="upload__label">CaO</label>
          <input value="${currentOriginalRow.countCaO}" required name="countCaO" type="number" step="0.01" min="0"/>
          <label class="upload__label">MgO</label>
          <input value="${currentOriginalRow.countMgO}" required name="countMgO" type="number" step="0.01" min="0"/>
          <label class="upload__label">SO3</label>
          <input value="${currentOriginalRow.countSO3}" required name="countSO3" type="number" step="0.01" min="0"/>

          </div> 
          <button class="btn uploadCrop__btn">
          <span>Salva</span>
          </button>`;
  if (type === "sector") {
    //Create companyMarkup
    const originalCompanyRows = companyRowsValid(companyRows);
    const currCompany = originalCompanyRows.find(
      (company) => company.companyId === currentOriginalRow.companyId,
    );
    const companyMarkup = `${currCompany.companyId} - ${currCompany.company}`;
    console.log(companyMarkup);

    //Create cropMarkup
    const originalCropRows = cropRowsValid(cropRows);
    console.log(originalCropRows);
    const currCrop = originalCropRows.find(
      (crop) => crop.cropId === currentOriginalRow.cropId,
    );
    const cropMarkup = `${currCrop.cropId} - ${currCrop.crop}`;

    markup = `<div    class="upload__column_sector">
              <h3 class="upload__heading">Modifica Settore</h3>
              <label class="upload__label_company">Descrizione</label>
              <input class="input_company" value="${currentOriginalRow.name}" required name="name" type="text"/>
              
              <label class="upload__label">Azienda</label>
               <select name ="company" id="select-company" >
                <option value=""> ${companyMarkup}</option>
                    </select> 

              <label class="upload__label">Coltura</label>
              <select name="crop" id="crop-select" >
                <option value=""> ${cropMarkup}</option>
                    </select>
              
                    
              <label class="upload__label">Lunghezza (m)</label>
              <input  value="${currentOriginalRow.length}" required name="length" type="number" step="0.01" min="0"/>
              <label class="upload__label">Larghezza (m)</label>
              <input  value="${currentOriginalRow.width}" required name="width" type="number" step="0.01" min="0"/>
              <label class="upload__label">Area (ha)</label>
              <input name="area" type="number" step="0.0001" min="0" id="sector-area-input" readonly style="background:#f0f0f0;"/>
              <label class="upload__label">Distanza tra le file di erogazione(m)</label>
              <input  value="${currentOriginalRow.distanceSupplyRows}" required name="distanceSupplyRows" type="number" step="0.01" min="0"/>
              <label class="upload__label">Distanza tra gli erogatori (cm)</label>
              <input  value="${currentOriginalRow.distanceSuppliers}" required name="distanceSuppliers" type="number" step="0.01" min="0"/>
              <label class="upload__label">Portata nominale dell'erogatore a pressione d'esercizio prescelta (l/h)</label>
              <input  value="${currentOriginalRow.nominalFlowRate}" required name="nominalFlowRate" type="number" step="0.01" min="0"/>
              <label class="upload__label">Portata di fertiniezione, da curva pressione-portata data dal costruttore, per pressione d'esercizio prescelta (l/h)</label>
              <input  value="${currentOriginalRow.fertiFlowRate}" required name="fertiFlowRate" type="number" step="0.01" min="0"/>
              <label class="upload__label">Lunghezza tubi collettori (m)</label>
              <input  value="${currentOriginalRow.pipeLength}" required name="pipeLength" type="number" step="0.01" min="0"/>
              
              
              
          
              </div> 
              <button class="btn upload__btn uploadSector__btn">
              <span>Salva</span>
              </button>`;
  }

  // Add live calculation for Area (ha) when rendering the form
  setTimeout(() => {
    const lengthInput = document.getElementById("sector-length-input");
    const widthInput = document.getElementById("sector-width-input");
    const areaInput = document.getElementById("sector-area-input");
    if (lengthInput && widthInput && areaInput) {
      const updateArea = () => {
        const length = parseFloat(lengthInput.value) || 0;
        const width = parseFloat(widthInput.value) || 0;
        const area = (length * width) / 10000;
        areaInput.value = area > 0 ? area.toFixed(4) : "";
      };
      lengthInput.addEventListener("input", updateArea);
      widthInput.addEventListener("input", updateArea);
    }
  }, 0);

  return markup;
};

export const createUpdatedRow = function (
  type,
  currRowId,
  inputValues,
  currRow,
) {
  console.log(inputValues, type);
  let updatedRow;
  if (type === "company")
    updatedRow = {
      companyId: currRowId,
      company: inputValues.company,
      address: {
        street: inputValues.street,
        city: inputValues.city,
        province: inputValues.province,
        country: inputValues.country,
      },
      tel: inputValues.tel,
    };
  if (type === "product")
    updatedRow = {
      productId: currRowId,
      product: inputValues.product,
      countN: inputValues.countN,
      countP2O5: inputValues.countP2O5,
      countK2O: inputValues.countK2O,
      countCaO: inputValues.countCaO,
      countMgO: inputValues.countMgO,
      countSO3: inputValues.countSO3,
      countEurokg: inputValues.countEurokg,
    };
  if (type === "fertiProduct")
    updatedRow = {
      productId: currRowId,
      product: inputValues.product,
      countN: inputValues.countN,
      countP2O5: inputValues.countP2O5,
      countK2O: inputValues.countK2O,
      countCaO: inputValues.countCaO,
      countMgO: inputValues.countMgO,
      countSO3: inputValues.countSO3,
      countEurokg: inputValues.countEurokg,
      conductivity: inputValues.conductivity,
      specificWeight: inputValues.specificWeight,
      solubilCoeff: inputValues.solubilCoeff,
    };
  if (type === "crop")
    updatedRow = {
      cropId: currRowId,
      crop: inputValues.crop,
      countN: inputValues.countN,
      countP2O5: inputValues.countP2O5,
      countK2O: inputValues.countK2O,
      countCaO: inputValues.countCaO,
      countMgO: inputValues.countMgO,
      countSO3: inputValues.countSO3,
    };
  if (type === "sector")
    updatedRow = {
      sectorId: currRowId,
      name: inputValues.name,
      companyId: inputValues.company,
      cropId: inputValues.crop,
      length: inputValues.length,
      width: inputValues.width,
      distanceSupplyRows: inputValues.distanceSupplyRows,
      distanceSuppliers: inputValues.distanceSuppliers,
      nominalFlowRate: inputValues.nominalFlowRate,
      fertiFlowRate: inputValues.fertiFlowRate,
      pipeLength: inputValues.pipeLength,
    };
  console.log(updatedRow);
  return updatedRow;
};

export const checkSortRows = function (tableWindow) {
  tableWindow.addEventListener("click", function (e) {
    e.preventDefault();
    const table = tableWindow.querySelector(".myTable");
    const tbody = table.querySelector("tbody");
    const rows = Array.from(tbody.querySelectorAll("tr"));

    console.log(rows);

    const target = e.target;
    const parentEl = target.closest(".headerColumn");
    if (!parentEl) return;
    console.log(target, parentEl);
    //if (!parentEl.classList.contains("headerColumn")) return;

    if (parentEl.classList.contains("headerColumn")) {
      console.log("header clicked");
      const columnClicked = parentEl.getAttribute("data-column");
      console.log(columnClicked);

      sortRows(columnClicked, rows, tbody);
    }
  });
};

const sortRows = function (columnIndex, rows, tbody) {
  rows.sort((rowA, rowB) => {
    let cellA = rowA.cells[columnIndex].textContent.trim().toLowerCase();
    let cellB = rowB.cells[columnIndex].textContent.trim().toLowerCase();

    return cellA.localeCompare(cellB);
  });

  rows.forEach((row) => tbody.appendChild(row));
};

//4.Add action buttons
const addActionsMarkup = function (type, r, rowId, currAccStatus) {
  let actions = "";
  if (currAccStatus === "admin") {
    actions =
      actions +
      `
        <img src='/icons/euro-logo.png' class="tiny_icon euro-tiny_icon" data-row=${r[rowId]}></img>
      ` +
      `
        <img src='/icons/update_img.jpeg' class="tiny_icon update-tiny_icon" data-row=${r[rowId]}></img>
      ` +
      `
        <img src='/icons/delete_icon.jpeg' class="tiny_icon delete-tiny_icon" data-row=${r[rowId]}></img>
      `;
  }
  return actions;
};
